import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { Language, LanguageService } from '@lx/language';
import { CourseTypeService } from '@lx/quote-tool/shared/data-access/course';
import { CountryService } from '@lx/quote-tool/shared/data-access/destination';
import { QuoteSchoolService } from '@lx/quote-tool/shared/data-access/school';
import { QuoteSchool } from '@lx/quote-tool/shared/types/school';
import { Country } from '@lx/shared/data-access/types';
import { ResidenceCountry, ResidenceCountryService } from '@lx/shared/data-access/destination';
import { QuoteInput } from '@lx/quote-tool/shared/types/quote';
import { CourseType } from '@lx/shared/data-access/types';
import { combineLatest, Observable } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';
import { HostDataReaderService } from '@lx/quote-tool/shared/services';

export interface QuoteFormResolvedData {
  languages: Language[];
  countries: Country[];
  schools: QuoteSchool[];
  courseTypes: CourseType[];
  residenceCountries: ResidenceCountry[];
  prefilled?: Partial<QuoteInput>;
  referrer?: string;
}

@Injectable({
  providedIn: 'root',
})
export class QuoteFormDataResolver {
  constructor(
    private readonly languageService: LanguageService,
    private readonly countryService: CountryService,
    private readonly schoolService: QuoteSchoolService,
    private readonly courseTypeService: CourseTypeService,
    private readonly residenceCountryService: ResidenceCountryService,
    private readonly hostDataReader: HostDataReaderService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  public resolve(): Observable<QuoteFormResolvedData> {
    return combineLatest([
      this.languageService.getAll(),
      this.countryService.getAll(),
      this.schoolService.getAll(),
      this.courseTypeService.getAll(),
      this.residenceCountryService.getAll(),
    ]).pipe(
      take(1),
      mergeMap(([languages, countries, schools, courseTypes, residenceCountries]: [Language[], Country[], QuoteSchool[], CourseType[], ResidenceCountry[]]) => {
        return this.hostDataReader.getPrefilledSchoolCourse$().pipe(
          map((prefilled) => ({
            languages,
            countries,
            schools,
            courseTypes,
            residenceCountries,
            prefilled,
            referrer: this.document.referrer,
          })),
        );
      }),
    );
  }
}
